<template>
  <div v-if="dataModel!=null" class>
    <!-- header start -->
    <van-nav-bar
      :title="dataModel.NickName+'的团队'"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <section class="team-banner">
        <div class="hd">
          <van-image round width="100%" height="100%" fit="cover" :src="dataModel.HeadPic" />
        </div>
        <div class="bd">
          <div class="name">{{dataModel.NickName}}</div>
          <p class="people">
            一级共
            <span class="num">{{dataModel.MRelationCount}}</span>人
          </p>
        </div>
        <!-- <div class="ft">
        <div class="money">￥{{dataModel.TotalCommission}}</div>
        <div class="text">一级总业绩</div>
        </div>-->
      </section>

      <van-search v-model="keyword" show-action placeholder="搜索关键词" @search="onSearch">
        <template #action>
          <van-button class="mybtn" size="small" @click="onSearch"  style="height:34px">搜索</van-button>
        </template>
      </van-search>

      <!--Dev:: data-sort 升序为asc,降序为desc,默认为升序-->
      <!-- <section class="filter">
      <div class="filter-item active" data-sort="desc">
        <router-link to="#" class="navigation">
          消费金额
          <i class="filter-item-price"></i>
        </router-link>
      </div>
      <div class="filter-item" data-sort="desc">
        <router-link to="#" class="navigation">
          业绩
          <i class="filter-item-price"></i>
        </router-link>
      </div>
      <div class="filter-item" data-sort="desc">
        <router-link to="#" class="navigation">
          加入时间
          <i class="filter-item-price"></i>
        </router-link>
      </div>
      </section>-->
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div class="team-list" v-for="item in dataList" :key="item.Id">
          <div class="hd">
            <div class="avatar">
              <van-image
                round
                width="100%"
                height="100%"
                fit="cover"
                :src="item.HeadPic"
              />
            </div>
            <!-- <span class="total">64679</span> -->
          </div>
          <div class="bd">
            <div class="name">{{item.NickName}}</div>
            <p class="info-item">等级：{{item.DistributionLevelName}}</p>
            <p class="info-item">{{item.AddDateTime}}</p>
          </div>
          <div class="ft">
            <div class="price">￥{{item.TotalCommission}}</div>
            <!-- <div class="des">业绩</div> -->
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: "",
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      dataModel: null
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      var _memberId = that.$route.query.MemberId;
      that.options = {
        type: "MemberRelationSearch",
        pageIndex: 1,
        MemberId: _memberId
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        res => {
          console.log(res);
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.MemberRelationList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.MemberRelationList.length > 0) {
              res.MemberRelationList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.MemberRelationList;
          }
          that.dataModel = res.TotalDistributionCommission;
        },
        error => {
          console.log(error);
        }
      );
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onSearch() {
      //console.log(this.keyword)
      Object.assign(this.options, {
          nickName:this.keyword
      });
       this.getList();
    }
  }
};
</script>

<style scoped>
.team-banner {
  background: url("~@/assets/images/me/wallet-bg.jpg") center no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  display: flex;
  align-items: center;
}
.team-banner > .hd {
  width: 72px;
  height: 72px;
  margin-right: 15px;
}
.team-banner > .bd {
  flex: 1;
  overflow: hidden;
}
.team-banner > .bd .name {
  font-size: 20px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.team-banner > .bd .people {
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.team-banner > .bd .people .num {
  font-size: 20px;
}
.team-banner > .ft {
  flex: 1;
  overflow: hidden;
  text-align: center;
}
.team-banner > .ft .money {
  font-size: 20px;
  color: #fff;
}
.team-banner > .ft .text {
  font-size: 15px;
  color: #fff;
}
.filter {
  display: flex;
  background: #fff;
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  border-bottom: 1px solid #e9ecf0;
}
.filter-item {
  text-align: center;
  padding: 0 16px;
}
.filter-item-price {
  position: relative;
  top: 2px;
  margin-left: 4px;
}
.filter-item-price::after,
.filter-item-price::before {
  content: "";
  display: block;
  position: absolute;
  top: -1px;
  left: 0;
  width: 0;
  height: 0;
  font-size: 0;
  border: 4px solid transparent;
}
.filter-item-price::before {
  border-bottom-color: #b4babf;
}
.filter-item-price::after {
  border-top-color: #b4babf;
  top: 8px;
}
.filter-item.active[data-sort] .filter-item-price::before {
  border-bottom-color: #f60;
}
.filter-item.active[data-sort="desc"] .filter-item-price::after {
  border-top-color: #f60;
}
.filter-item.active[data-sort="desc"] .filter-item-price::before {
  border-bottom-color: #b4babf;
}
.team-list {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 14px;
  margin: 10px;
  border-radius: 8px;
}
.team-list > .hd {
  width: 80px;
  margin-right: 15px;
  position: relative;
}
.team-list > .hd .avatar {
  width: 80px;
  height: 80px;
}
.team-list > .hd .total {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 12px;
  color: #fff;
  padding: 0 6px;
  border-radius: 4px;
  background: #f60;
}
.team-list > .bd {
  flex: 1;
  overflow: hidden;
}
.team-list > .bd .name {
  font-size: 16px;
  margin-bottom: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.team-list > .bd .info-item {
  font-size: 13px;
  color: #777;
}
.team-list > .ft {
  margin-left: 12px;
  width: 80px;
  text-align: right;
}
.team-list > .ft .price {
  font-size: 24px;
  color: #f60;
}
.team-list > .ft .des {
  font-size: 13px;
  color: #999;
}
</style>
